<template>
  <code class="bg-gray-50 text-gray-900 overflow-hidden rounded-md p-[3px] text-sm font-normal">
      <slot />
    </code>
</template>

<style lang="postcss" scoped>
code {
  &.colored {
    @apply bg-gray-900;
  }
}

tbody code {
  @apply text-sm;
}

a {
  @apply overflow-hidden;

  code {
    @apply text-primary-500 dark:text-primary-500 border border-dashed border-transparent font-medium;
  }
}

a:hover code {
  @apply border-primary-500 dark:border-primary-500;
}

h1 a,
h2 a,
h3 a,
h4 a {
  code {
    @apply text-gray-900 relative px-2 py-1.5 font-bold;
    font-size: inherit !important;
  }
}
</style>
